import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import NotifyAdmin from '../notification/NotifyAdmin';
import '../../styles/TotalUsers.css';

const ReferralUsers = () => {
    const [email, setEmail] = useState('');
    const [user, setUser] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [referrals, setReferrals] = useState([]);
    const [updating, setUpdating] = useState(false);
    const [userEmails, setUserEmails] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        const fetchTotalUsers = async () => {
            try {
                const response = await axiosInstance.get('/api/users');
                setTotalUsers(response.data.users.length);
                setIsAdmin(response.data.isAdmin);
                setUserEmails(response.data.users.map(user => user.email));
            } catch (error) {
               // console.error('Error fetching total users:', error);
            }
        };

        const fetchNotifications = async () => {
            try {
                const response = await axiosInstance.get('/api/notifications');
                setNotifications(response.data.notifications);
            } catch (error) {
               // console.error('Error fetching notifications:', error);
            }
        };

        fetchTotalUsers();
        fetchNotifications();
    }, []);

    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axiosInstance.get('/api/users');
            const foundUser = response.data.users.find(user => user.email === email);
            if (foundUser) {
                setUser(foundUser);
                await fetchUserReferrals(foundUser.id);
            } else {
                setUser(null);
                setNotifications((prevNotifications) => [
                    ...prevNotifications,
                    { id: Date.now(), message: 'User not found', isError: true },
                ]);
            }
        } catch (error) {
           // console.error('Error fetching user by email:', error);
            setNotifications((prevNotifications) => [
                ...prevNotifications,
                { id: Date.now(), message: 'User not found', isError: true },
            ]);
        } finally {
            setLoading(false);
        }
    };

    const fetchUserReferrals = async (userId) => {
        try {
            const response = await axiosInstance.get(`/api/users/${userId}/referrals`);
            setReferrals(response.data.referrals);
        } catch (error) {
          //  console.error('Error fetching user referrals:', error);
            setNotifications((prevNotifications) => [
                ...prevNotifications,
                { id: Date.now(), message: 'Error fetching user referrals', isError: true },
            ]);
        }
    };

    const handleUpdateReferrals = async () => {
        setUpdating(true);

        try {
            await axiosInstance.post(`/api/users/${user.id}/update-referrals`);
            await fetchUserReferrals(user.id);
            setNotifications((prevNotifications) => [
                ...prevNotifications,
                { id: Date.now(), message: 'Referral commissions updated successfully.', isError: false },
            ]);
        } catch (error) {
          //  console.error('Error updating referrals:', error);
            setNotifications((prevNotifications) => [
                ...prevNotifications,
                { id: Date.now(), message: 'Error updating referrals', isError: true },
            ]);
        } finally {
            setUpdating(false);
        }
    };

    const handleInputChange = (e) => {
        setEmail(e.target.value);
        setSuggestions(
            userEmails.filter((userEmail) =>
                userEmail.toLowerCase().includes(e.target.value.toLowerCase())
            )
        );
    };

    const handleSuggestionClick = (suggestion) => {
        setEmail(suggestion);
        setSuggestions([]);
    };

    return (
        <div className='total-users'>
            <div className='user-search-section'>
                <div className='totalusers-header'>
                    <h1 className="total-users-header">Total Users: {totalUsers}</h1>
                </div>

                {isAdmin && (
                    <div className='total-users-search'>
                        <div className='total-users-search-top'>
                            <h2 className="search-title">Search User by Email</h2>
                            <form onSubmit={handleSearch}>
                                <input
                                    className="search-input-user"
                                    type="email"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={handleInputChange}
                                    required
                                />
                                <button className="search-button" type="submit" disabled={loading} style={{ marginTop: "10px" }}>
                                    {loading ? 'Searching...' : 'Search'}
                                </button>
                                {suggestions.length > 0 && (
                                    <ul className="suggestions-list">
                                        {suggestions.map((suggestion, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleSuggestionClick(suggestion)}
                                            >
                                                {suggestion}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </form>
                        </div>

                        <div className='total-users-search-bottom'>
                            {user && (
                                <div className="user-details">
                                    <h3>User Details:</h3>
                                    <p>Email: {user.email}</p>
                                    <p>ID: {user.id}</p>
                                    <p>Bank: {user.bank}</p>
                                    <p>Account Name: {user.accountName}</p>
                                    <p>Account Number: {user.accountNumber}</p>
                                    <p>Phone Number: {user.phoneNumber}</p>
                                    <p>Admin: {user.isAdmin ? 'Yes' : 'No'}</p>
                                    <p>Paid: {user.hasPaid ? 'Yes' : 'No'}</p>
                                    <h3>Paid Referrals: {referrals?.length} </h3>
                                    <h3>Amount: {referrals?.length * 25} </h3>
                                    {referrals.length > 0 ? (
                                        <ul>
                                            {referrals.map((referral) => (
                                                <li key={referral.id}>
                                                    Referred User ID: {referral.referredUserId}, Commission Paid: {referral.commissionPaid ? 'Yes' : 'No'}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>No paid referrals found.</p>
                                    )}
                                    <button onClick={handleUpdateReferrals} disabled={updating}>
                                        {updating ? 'Updating...' : 'Update Referrals'}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <div className='notification-section'>
                <NotifyAdmin notifications={notifications} />
            </div>
        </div>
    );
};

export default ReferralUsers;
